import "./CategoryFlyout.scss";
import { motion } from "framer-motion";

export function CategoryFlyout({ title, content }) {
	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
			transition={{ duration: 0.3, ease: [0.39, 0.39, 0.69, 0.69] }}
			className="category-flyout">
			<h1 className="category-flyout__title">{title}</h1>
			<div
				dangerouslySetInnerHTML={{ __html: content }}
				className="category-flyout__content"
			/>
		</motion.div>
	);
}
